import messages from './messages';

export const profileNavLinks = [
	{
		href: '/app/profile/stats',
		title: messages.myStats,
	},
	{
		href: '/app/profile/manage-subscription',
		title: messages.mySubscription,
	},
	{
		href: '/app/profile/account-settings',
		title: messages.myAccountSettings,
	},
	{
		href: '/app/profile/update-user',
		title: messages.myAccountDetails,
	},
	{
		href: '/app/profile/change-password',
		title: messages.changePassword,
	},
	{
		href: '/app/profile/language',
		title: messages.myLanguage,
	},
];
